import { Disclosure } from '@headlessui/react'
import type { FunctionComponent } from 'react'
import tw, { styled } from 'twin.macro'
import { HeadingH2 } from '../layout/Texts'
import {
  expandableTitle,
  StyledGridWithGaps,
  StyledMinus,
  StyledPlus,
} from './AccordionStyledComponents'

export const StyledHeadingH2 = styled(HeadingH2)<{ smallSize?: boolean }>(
  ({ smallSize }) => [
    tw`font-semibold`,
    smallSize && tw`col-start-2 col-span-full text-px-20`,
    !smallSize && tw`col-start-3 col-span-full`,
  ]
)

export const DisclosureButton: FunctionComponent<React.PropsWithChildren<{
  open: boolean
  title: string
  titleWhenExpanded?: string
  clickHandler?: (index: number, action: boolean) => void
  index?: number
  className?: string
  useAqua?: boolean
  smallSize?: boolean
}>> = ({
  open,
  title,
  titleWhenExpanded,
  clickHandler,
  index,
  useAqua,
  smallSize,
  className,
}) => {
  return (
    <>
      <Disclosure.Button
        tw="text-left w-full text-accentroGray-full focus:outline-none"
        className={className}
      >
        <StyledGridWithGaps
          useAqua={useAqua}
          onClick={() =>
            clickHandler && index ? clickHandler(index, open) : null
          }
        >
          {open ? (
            <StyledMinus $smallSize={smallSize} />
          ) : (
            <StyledPlus $smallSize={smallSize} />
          )}
          <StyledHeadingH2 smallSize={smallSize}>
            {expandableTitle(title, titleWhenExpanded, open)}
          </StyledHeadingH2>
        </StyledGridWithGaps>
      </Disclosure.Button>
    </>
  )
}
